module.exports = __webpack_public_path__ + "img/fisher-real.767fe738.png";